import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiButtonBackNewComponent } from './fi-button-back-new.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatIconModule],
    declarations: [FiButtonBackNewComponent],
    exports: [FiButtonBackNewComponent],
})
export class FiButtonBackNewModule {}
